/* eslint-disable no-nested-ternary */
// filepath: /Users/reizhafajrian/Documents/GitHub/komisi-admin/src/views/admin/product-digital/components/MyDigitalProducts.jsx
import {
  Box,
  Button,
  Flex,
  Text,
  SimpleGrid,
  Badge,
  Icon,
  Image,
  Heading,
  useDisclosure,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  ModalFooter,
  VStack,
  HStack,
  Divider,
  Tooltip,
  Input,
  InputGroup,
  InputLeftElement,
  Tag,
} from '@chakra-ui/react';
import React, { useState } from 'react';
import { FaEdit, FaYoutube, FaSearch } from 'react-icons/fa';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import Card from 'components/card/Card';
import DeleteDialog from 'components/deleteDialog';
import useApi from 'hooks/useApi';
import formatRupiah from 'lib/formatRupiah';
import useStore from 'store/useStore';

const MyDigitalProducts = () => {
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [searchQuery, setSearchQuery] = useState('');
  const { isOpen, onOpen, onClose } = useDisclosure();
  const history = useHistory();

  const { getDigitalProductsByAuthor, user, digitalProducts, deleteDigitalProducts } = useStore();

  // This would be replaced with actual API calls for digital products
  // For now, using mock data

  const { loading } = useApi({
    isImmediate: true,
    fetcher: getDigitalProductsByAuthor,
    params: { authorId: user._id },
  });
  const handleSearch = (e) => {
    setSearchQuery(e.target.value);
  };

  const filteredProducts = digitalProducts.data.filter(
    (product) =>
      product.title.toLowerCase().includes(searchQuery.toLowerCase()) ||
      product.description.toLowerCase().includes(searchQuery.toLowerCase()) ||
      product.tags.some((tag) => tag.toLowerCase().includes(searchQuery.toLowerCase())),
  );

  const handleViewDetails = (product) => {
    setSelectedProduct(product);
    onOpen();
  };

  const handleEditProduct = (productId) => {
    // Redirect to edit page
    history.push(`/admin/digital-products/edit/${productId}`);
  };

  const getTotalDuration = (content) => {
    return content.reduce((total, item) => total + (item.duration || 0), 0);
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
    });
  };

  return (
    <Box pt={{ base: '0px', md: '0px', xl: '0px' }}>
      {/* Search Bar */}
      <Flex mb={6}>
        <InputGroup size="md">
          <InputLeftElement pointerEvents="none">
            <Icon as={FaSearch} color="gray.300" />
          </InputLeftElement>
          <Input
            type="text"
            placeholder="Search digital products..."
            value={searchQuery}
            onChange={handleSearch}
            borderRadius="lg"
          />
        </InputGroup>
      </Flex>

      {loading ? (
        <Flex justify="center" align="center" height="200px">
          <Text>Loading products...</Text>
        </Flex>
      ) : filteredProducts.length === 0 ? (
        <Flex justify="center" align="center" height="200px" direction="column">
          <Text mb={4}>No digital products found</Text>
          <Button colorScheme="blue" onClick={() => window.location.reload()}>
            Create New Digital Product
          </Button>
        </Flex>
      ) : (
        <SimpleGrid columns={{ base: 1, md: 2, xl: 3 }} spacing="20px">
          {filteredProducts.map((product) => (
            <Card key={product._id} p="20px">
              <Box position="relative" borderRadius="xl" overflow="hidden" h="180px">
                <Image src={product.thumbnail} alt={product.title} w="100%" h="100%" objectFit="cover" />
                <Box
                  position="absolute"
                  top="10px"
                  right="10px"
                  borderRadius="full"
                  bg={product.isActive ? 'green.500' : 'red.500'}
                  color="white"
                  px={2}
                  py={1}
                  fontSize="sm"
                >
                  {product.isActive ? 'Active' : 'Inactive'}
                </Box>
              </Box>

              <Flex direction="column" mt={4}>
                <Flex justify="space-between" align="center">
                  <Heading size="md" noOfLines={1} title={product.title}>
                    {product.title}
                  </Heading>
                </Flex>

                <Text color="gray.500" fontSize="sm" mt={1}>
                  {product.category.name}
                </Text>

                <Text fontWeight="bold" fontSize="xl" mt={2}>
                  {formatRupiah(product.price)}
                </Text>

                <Text color="gray.600" fontSize="sm" mt={2} noOfLines={2} title={product.description}>
                  {product.description}
                </Text>

                <HStack mt={2}>
                  <Badge colorScheme="purple">{product.content.length} videos</Badge>
                  <Badge colorScheme="blue">{getTotalDuration(product.content)} mins</Badge>
                  <Badge colorScheme="orange">{product.purchaseCount} sales</Badge>
                </HStack>

                <Flex mt={4} wrap="wrap" gap={1}>
                  {product.tags.slice(0, 3).map((tag, index) => (
                    <Tag key={index} size="sm" variant="outline" colorScheme="blue">
                      {tag}
                    </Tag>
                  ))}
                  {product.tags.length > 3 && (
                    <Tag size="sm" variant="outline" colorScheme="gray">
                      +{product.tags.length - 3}
                    </Tag>
                  )}
                </Flex>

                <Flex mt={4} justify="space-between">
                  <Button onClick={() => handleViewDetails(product)} size="sm">
                    View Details
                  </Button>
                  <HStack>
                    <Tooltip label="Edit product">
                      <Button
                        onClick={() => handleEditProduct(product._id)}
                        size="sm"
                        colorScheme="blue"
                        variant="ghost"
                      >
                        <Icon as={FaEdit} />
                      </Button>
                    </Tooltip>
                    <Tooltip label="Delete product">
                      <DeleteDialog
                        handler={async (callback) => await deleteDigitalProducts({ productId: product._id }, callback)}
                        title={'Hapus'}
                        desc="Anda Yakin Ingin Menghapus Produk Ini?"
                      />
                    </Tooltip>
                  </HStack>
                </Flex>
              </Flex>
            </Card>
          ))}
        </SimpleGrid>
      )}

      {/* Delete Confirmation Dialog */}

      {/* Product Details Modal */}
      {selectedProduct && (
        <Modal isOpen={isOpen} onClose={onClose} size="xl">
          <ModalOverlay />
          <ModalContent>
            <ModalHeader>{selectedProduct.title}</ModalHeader>
            <ModalCloseButton />
            <ModalBody>
              <Image
                src={selectedProduct.thumbnail}
                alt={selectedProduct.title}
                borderRadius="md"
                w="100%"
                h="200px"
                objectFit="cover"
                mb={4}
              />

              <Flex justify="space-between" align="center" mb={2}>
                <Badge colorScheme={selectedProduct.isActive ? 'green' : 'red'}>
                  {selectedProduct.isActive ? 'Active' : 'Inactive'}
                </Badge>
                <Text color="gray.500" fontSize="sm">
                  Created on {formatDate(selectedProduct.createdAt)}
                </Text>
              </Flex>

              <Text mb={4}>{selectedProduct.description}</Text>

              <HStack mb={4}>
                <Badge colorScheme="blue">{selectedProduct.category.name}</Badge>
                <Badge colorScheme="orange">{selectedProduct.purchaseCount} sales</Badge>
                <Badge colorScheme="yellow">
                  {selectedProduct.ratings.average} ★ ({selectedProduct.ratings.count} reviews)
                </Badge>
              </HStack>

              <Text fontWeight="bold" mb={2}>
                Price: {formatRupiah(selectedProduct.price)}
              </Text>

              <Box mb={4}>
                <Text fontWeight="bold" mb={2}>
                  Tags:
                </Text>
                <Flex wrap="wrap" gap={2}>
                  {selectedProduct.tags.map((tag, index) => (
                    <Tag key={index} colorScheme="blue">
                      {tag}
                    </Tag>
                  ))}
                </Flex>
              </Box>

              <Divider my={4} />

              <Text fontWeight="bold" mb={4}>
                Content Items:
              </Text>
              <VStack align="stretch" spacing={4}>
                {selectedProduct.content.map((item, index) => (
                  <Box key={index} p={3} borderWidth="1px" borderRadius="md" position="relative">
                    <Flex justify="space-between">
                      <HStack>
                        <Icon as={FaYoutube} color="red.500" />
                        <Text fontWeight="medium">{item.title}</Text>
                      </HStack>
                      {item.isPrivate && <Badge colorScheme="purple">Private</Badge>}
                    </Flex>
                    <Text fontSize="sm" color="gray.500" mt={1}>
                      {item.duration} minutes • Order: {item.order}
                    </Text>
                    <Text fontSize="sm" color="blue.500" mt={1} noOfLines={1}>
                      {item.youtubeUrl}
                    </Text>
                  </Box>
                ))}
              </VStack>
            </ModalBody>
            <ModalFooter>
              <Button colorScheme="blue" mr={3} onClick={() => handleEditProduct(selectedProduct._id)}>
                Edit
              </Button>
              <Button variant="ghost" onClick={onClose}>
                Close
              </Button>
            </ModalFooter>
          </ModalContent>
        </Modal>
      )}
    </Box>
  );
};

export default MyDigitalProducts;
